<template>
  <div class="expressdetail">
    <div class="myspespace"></div>
    <div class="con">
      <div class="title">运单号: {{order.waybillNo}}</div>
      <div class="sendgetcon">
        <div class="sendget send">
          <div class="left">
            <div class="round">寄</div>
          </div>
          <div class="center">
            <div class="title">{{order.jContact}} {{order.jMobile}}</div>
            <div class="address">{{order.jProvince}} {{order.jCity}} {{order.jAddress}}</div>
          </div>
          <div class="right"></div>
        </div>
        <div class="sendget get">
          <div class="left">
            <div class="round">收</div>
          </div>
          <div class="center">
            <div class="title">{{order.dContact}} {{order.dMobile}}</div>
            <div class="address">{{order.dProvince}} {{order.dCity}} {{order.dAddress}}</div>
          </div>
          <div class="right"></div>
        </div>
      </div>
      <div style="overflow:hidden;">
        <van-form>
          <van-field
            class="myvanfield"
            v-model="order.sendStartTime"
            label="寄件时间"
            readonly
            placeholder=""
          />
          <van-field
            class="myvanfield"
            value="顺丰标快"
            label="快递类型"
            readonly
            placeholder="请输入快递类型"
          />
          <!--
          <van-field
            class="myvanfield"
            v-model="order.parcelWeighs"
            label="预估重量"
            placeholder=""
          /> -->
          <van-field
            class="myvanfield"
            v-model="order.remark"
            label="寄方备注"
            readonly
            placeholder="请输入备注内容"
          />
          <van-field
            class="myvanfield"
            v-model="order.shipping_fee"
            label="运费"
            readonly
            placeholder="请输入备注内容"
          />
          <van-field
            class="myvanfield"
            label="保价"
            readonly
            v-model="order.insured_fee"
            placeholder="保价"
          />
          <van-field
            class="myvanfield"
            v-model="order.other_fee"
            label="其他"
            readonly
            placeholder="其他费用"
          />
          <van-field
            class="myvanfield"
            label="优惠金额"
            placeholder=""
            readonly
          >
            <template #button>
              <van-button size="small" class="mycouponbtn" type="primary">优惠券</van-button>
              <span class="red">-￥{{order.discount_fee}}</span>
            </template>
          </van-field>
          <van-field
            class="myvanfield myspevanfield"
            v-model="order.total_fee"
            label="实际支付费用"
            readonly
            placeholder="请输入备注内容"
          />
          <div class="des">*发票请致电客服电话400-990-2557</div>
          <van-button v-show="order.orderStatus === '未下单' || order.orderStatus === '未揽收'" class="btn2" @click.stop="cancelItem(order)" plain type="danger">取消</van-button>
        </van-form>
      </div>
    </div>
    <div class="con con2" v-if="routes && routes.length > 0">
      <van-steps class="mysteps" direction="vertical" @step-line-color="'#000000'" :active="0">
        <van-step v-for="(item, index) in routes" :key="index">
          <h3>【{{item.acceptAddress}}】{{item.remark}}</h3>
          <p>{{item.acceptTime}}</p>
        </van-step>
      </van-steps>
    </div>
    <div class="spf"></div>
    <van-button class="mybtn" type="primary" @click="gohome" block>返回首页</van-button>
  </div>
</template>
<script>
window.myback = false
document.addEventListener('back', function(e) {
  if (window.myback === true) {
    window.location = window.location.origin + '/sf/home'
    e.preventDefault()
  }
}, false)
import { sfDetail, cancelOrder } from '@/api/modules/sf'
import { Dialog, Toast } from 'vant'
export default {
  name: 'expressdetail',
  components: {
  },
  data() {
    return {
      subdata: {
        value1: ''
      },
      router: null,
      routes: [],
      order: {
        waybillNo: '',
        parcelWeighs: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    // 这里表示不是从搜索页面过来的
    if (from.fullPath !== '/sf/search' && from.fullPath !== '/sf/waitpay') {
      window.myback = true
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (this.choosedData) {
      to.query.active = this.$route.query.active
    }
    next()
  },
  computed: {
  },
  created() {
    if (this.$route.query.sf_order_id) {
      sfDetail({
        sf_order_id: this.$route.query.sf_order_id
      }).then((res) => {
        if (res.data.status_code === 200) {
          this.router = res.data.route
          this.routes = res.data.route.routes
          this.order = res.data.order
          this.order.parcelWeighs = res.data.order.parcelWeighs ? res.data.order.parcelWeighs + 'kg' : ''
        }

      })
    }
  },
  methods: {
    cancelItem(item) {
      console.log(item)
      Dialog.confirm({
        title: '确认',
        message: '确认取消订单'
      })
        .then(() => {
          cancelOrder({
            'sf_order_id': item.sf_order_id
          }).then((res) => {
            if (res.data.status_code === 200) {
              Toast('撤单成功')
              this.reSearch()
            }
            else {
              Toast(res.data.message)
            }
          })
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    gohome() {
      this.$router.push('/sf/home')
    }
  }
}
</script>
<style lang="less">
  .van-step{
    color:#444444;
  }
  .mysteps{
    font-size:24px;
    .van-step__line{
      background: #000000;
      margin-top:18px;
    }
    .van-step--vertical{
      font-size:24px;
      padding-top:0px !important;
      padding-left:30px !important;
      line-height:34px;
    }
    .van-icon{
      font-size:30px !important;
    }
    .van-step__circle{
      width:24px !important;
      height:24px !important;
    }
  }
  .myspevanfield{
    .van-field__value{
      .van-field__control{
        color:red;
      }
    }
  }
</style>
<style lang="less" scoped>
  .expressdetail{
    min-height:100vh;
    background-color: #f4f5fb;
    .mybtn{
      width: 750px;
      height: 94px;
      font-weight: 500;
      font-size: 36px;
      color: #000000;
      line-height: 48px;
      background-color:#ffffff;
      border:0px;
    }
    .btn2{
      background-color:red;
      border-radius: 10px;
      border: 4px solid red;
      float:right;
      font-size:24px;
      margin-right:20px;
      margin-bottom:20px;
      padding:20px 30px;
      color:#ffffff;
    }
    .spf{
      height:50px;
    }
    .con2{
      padding-left:20px;
      border-radius: 20px;
    }
    .con{
      margin:0px 15px 15px 15px;
      background-color:#ffffff;
      padding-top:20px;
      border-radius: 20px;
      .title{
        font-weight: 400;
        font-size: 30px;
        color: #444444;
        line-height: 60px;
        margin-left:15px;
      }
      .sendgetcon{
        margin:0px 15px;
        background: #F7F7F7;
        border-radius: 20px;
        border: 0px solid #F099BA;
      }
      .sendget{
        min-height: 143px;
        display:flex;
        .left{
          width:20%;
          display:flex;
          align-items: center;
        }
        .center{
          flex:1;
          .title{
            font-weight: 400;
            font-size: 30px;
            color: #444444;
            line-height: 31px;
            padding-top:15px;
            margin-bottom:15px;
          }
          .address{
            font-weight: 400;
            font-size: 24px;
            color: #999999;
            line-height: 31px;
            padding-bottom:10px;
          }
        }
        .right{
          width:10%;
          display:flex;
          align-items: center;
          .arrow{
            color:#A9A9A9;
            font-size:50px;
            margin:0px auto;
          }
        }
      }
      .send{
        .round{
          width:50px;
          height:50px;
          margin:0px auto;
          border-radius: 25px;
          background-color:#000000;
          font-weight: 400;
          font-size: 30px;
          color: #FCFCFC;
          line-height: 49px;
          text-align:center;
        }
      }
      .get{
        .round{
          width:50px;
          height:50px;
          margin:0px auto;
          border-radius: 25px;
          background-color:#E60012;
          font-weight: 400;
          font-size: 30px;
          color: #FCFCFC;
          line-height: 49px;
          text-align:center;
        }
      }
      .myvanfield{
        margin-bottom:0px;
        padding-top:0px;
        padding-bottom:0px;
        .red{
          color:#EB3442;
        }
        .mycouponbtn{
          width:109px;
          height:32px;
          vertical-align: middle;
          margin-right:20px;
          background-image:url("../../../assets/img/common/couponbg2.png");
          background-size:100% 100%;
          background-repeat: no-repeat;
          border:0px;
          border-radius: 6px;
          overflow:hidden;
          font-size:22px;
        }
      }
      .des{
        font-weight: 400;
        font-size: 24px;
        color: #E60012;
        text-align:left;
        padding-left:10px;
        padding-bottom:20px;
      }
    }
    .mysteps{
      font-size:24px;
      .van-step--vertical{
        font-size:24px;
      }
      .van-icon{
        font-size:20px !important;
      }
    }
  }
</style>
